import { CategoryTileProps } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTile';
import { NextCategoryTileImg } from 'components/PreauthV3/NextCategoryTileImage';

const AtHomeSpaDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/AtHomeSpa.jpg';
const BedroomUpgradesDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/BedroomUpgrades.jpg';
const BuildYourBarDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/BuildYourBar.jpg';
const ExclusiveToZolaDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/ExclusivetoZola.jpg';
const FeaturedBrandsDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/FeaturedBrands.jpg';
const MostPopularGiftsDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/MostPopularGifts.jpg';
const NewArrivalsDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/NewArrivals.jpg';
const OutdoorFunAdventureDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/OutdoorFunAdventure.jpg';
const RefreshYourHomeDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/RefreshYourHome.jpg';
const RegistryEssentialsDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/RegistryEssentials.jpg';
const TopRatedProductsDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/TopRatedProducts.jpg';
const UltimateKitchenEssentialsDesktop =
  '/static-preauth/images/WeddingRegistryLP/V3/Collections/Desktop/UltimateKitchenEssentials.jpg';

const atHomeSpaDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={AtHomeSpaDesktop} alt="" square />,
  linkText: 'At home spa',
  href: '/shop/collection/at-home-spa',
};

const bedroomUpgradesDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={BedroomUpgradesDesktop} alt="" square />,
  linkText: 'Bedroom upgrades',
  href: '/shop/collection/bedroom-upgrades-under-100',
};

const buildYourBarDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={BuildYourBarDesktop} alt="" square />,
  linkText: 'Build your bar',
  href: '/shop/collection/build-your-bar',
};

const exclusiveToZolaDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={ExclusiveToZolaDesktop} alt="" square />,
  linkText: 'Exclusive to Zola',
  href: 'shop/collection/zola-exclusives',
};

const featuredBrandsDesktopItem: CategoryTileProps = {
  altText: 'A woman using a lilac Kitchen Aid Artisan mixer.',
  imageElement: (
    <NextCategoryTileImg
      image={FeaturedBrandsDesktop}
      alt="A woman using a lilac Kitchen Aid Artisan mixer."
    />
  ),
  linkText: 'Featured brands',
  href: '/shop/brands',
};

const mostPopularGiftsDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={MostPopularGiftsDesktop} alt="" square />,
  linkText: 'Most popular gifts',
  href: '/shop/collection/top-registry-gifts-this-week',
};

const newArrivalsDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={NewArrivalsDesktop} alt="" square />,
  linkText: 'New arrivals',
  href: '/shop/collection/new-arrivals',
};

const outdoorFunDesktopItem: CategoryTileProps = {
  altText: 'Cooking a pizza using an Ooni Koda Gas Powered Pizza Oven.',
  imageElement: (
    <NextCategoryTileImg
      image={OutdoorFunAdventureDesktop}
      alt="Cooking a pizza using an Ooni Koda Gas Powered Pizza Oven."
    />
  ),
  linkText: 'Outdoor fun & adventure',
  href: '/shop/collection/fun-adventure',
};

const refreshYourHomeDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={RefreshYourHomeDesktop} alt="" square />,
  linkText: 'Refresh your home',
  href: '/shop/collection/upgrade-your-home',
};

const registryEssentialsDesktopItem: CategoryTileProps = {
  altText: 'A woman holding a black Sonos Roam portable smart speaker.',
  imageElement: (
    <NextCategoryTileImg
      image={RegistryEssentialsDesktop}
      alt="A woman holding a black Sonos Roam portable smart speaker."
    />
  ),
  linkText: 'Registry essentials',
  href: '/shop/collection/zola-registry-essentials',
};

const topRatedProductsDesktopItem: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={TopRatedProductsDesktop} alt="" square />,
  linkText: 'Top rated products',
  href: '/shop/collection/top-rated-kitchen-products',
};

const ultimateKitchenEssentialDesktopItem: CategoryTileProps = {
  altText:
    'The Caraway Marigold Cookware set, including a fry pan, a sauce pan, a sauté pan, and a dutch oven.',
  imageElement: (
    <NextCategoryTileImg
      image={UltimateKitchenEssentialsDesktop}
      alt="The Caraway Marigold Cookware set, including a fry pan, a sauce pan, a sauté pan, and a dutch oven."
    />
  ),
  linkText: 'Ultimate kitchen essentials',
  href: '/shop/collection/top-kitchen-essentials',
};

export const collectionsCategoryItemAlt = [
  newArrivalsDesktopItem,
  registryEssentialsDesktopItem,
  mostPopularGiftsDesktopItem,
  ultimateKitchenEssentialDesktopItem,
  buildYourBarDesktopItem,
  atHomeSpaDesktopItem,
  bedroomUpgradesDesktopItem,
  refreshYourHomeDesktopItem,
  exclusiveToZolaDesktopItem,
  outdoorFunDesktopItem,
  featuredBrandsDesktopItem,
  topRatedProductsDesktopItem,
];
